import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, User, LogIn, Plus } from 'lucide-react';

export const Header = ({ 
  currentUser, 
  acquirerAdsCount,
  onLoginClick,
  onAboutClick,
  onCreateAdClick,
  onLogout
}) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isAcquereur = currentUser?.user_type === 'acquereur' || currentUser?.user_type === 'both';
  const isVendeur = currentUser?.user_type === 'vendeur' || currentUser?.user_type === 'both';

  return (
    <header className="sticky top-0 z-50 bg-black text-white border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="hidden md:flex items-center justify-between">
          <div className="flex items-center gap-8 cursor-pointer" onClick={() => navigate('/')}>
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_maison-antibes/artifacts/rfdm9mit_image.png" 
                alt="OMERO Logo" 
                className="h-10 w-auto mb-1"
              />
              <p className="font-body text-sm text-gray-400">L'immobilier inversé C2C</p>
            </div>
          </div>
          
          <div className="flex items-center gap-6">
            <div className="text-sm text-gray-300">
              {acquirerAdsCount} acquéreurs actifs
            </div>
            
            <button
              onClick={onAboutClick}
              className="w-8 h-8 rounded-full border-2 border-white/30 text-white hover:border-accent hover:text-accent transition-colors flex items-center justify-center font-bold"
              title="Qu'est-ce qu'Omero ?"
            >
              ?
            </button>
            
            {currentUser ? (
              <>
                <button
                  onClick={() => navigate('/mon-compte')}
                  className="text-sm text-gray-300 hover:text-white transition-colors font-medium"
                >
                  {currentUser.name}
                </button>
                {isAcquereur && (
                  <Button
                    onClick={onCreateAdClick}
                    className="bg-accent hover:bg-accent/90 text-black font-semibold px-6"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Publier
                  </Button>
                )}
              </>
            ) : (
              <>
                <Button
                  onClick={onLoginClick}
                  variant="ghost"
                  className="text-white hover:text-accent"
                >
                  <LogIn className="w-4 h-4 mr-2" />
                  Connexion
                </Button>
                <Button
                  onClick={onCreateAdClick}
                  className="bg-accent hover:bg-accent/90 text-black font-semibold px-6"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Publier
                </Button>
              </>
            )}
          </div>
        </div>

        <div className="md:hidden">
          <div className="flex items-center justify-between">
            <div className="cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://customer-assets.emergentagent.com/job_maison-antibes/artifacts/rfdm9mit_image.png" 
                alt="OMERO Logo" 
                className="h-7 w-auto"
              />
            </div>
            <Button
              onClick={() => setMenuOpen(!menuOpen)}
              variant="ghost"
              size="icon"
              className="text-white"
            >
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </Button>
          </div>

          {menuOpen && (
            <div className="mt-6 space-y-3 py-4 border-t border-gray-800">
              {currentUser ? (
                <>
                  <button
                    onClick={() => { navigate('/mon-compte'); setMenuOpen(false); }}
                    className="w-full text-left py-3 text-white hover:text-accent transition-colors"
                  >
                    Mon compte
                  </button>
                  {isAcquereur && (
                    <Button
                      onClick={() => { onCreateAdClick(); setMenuOpen(false); }}
                      className="w-full bg-accent hover:bg-accent/90 text-black font-semibold"
                    >
                      Publier une annonce
                    </Button>
                  )}
                </>
              ) : (
                <Button
                  onClick={() => { onLoginClick(); setMenuOpen(false); }}
                  className="w-full bg-white text-black hover:bg-gray-100"
                >
                  Connexion
                </Button>
              )}
              <button
                onClick={() => { onAboutClick(); setMenuOpen(false); }}
                className="w-full text-left py-3 text-gray-300 hover:text-white transition-colors"
              >
                Qu'est-ce qu'Omero ?
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
